import { render, staticRenderFns } from "./PresentPublication.vue?vue&type=template&id=60ed2f44"
import script from "./PresentPublication.vue?vue&type=script&lang=js"
export * from "./PresentPublication.vue?vue&type=script&lang=js"
import style0 from "./PresentPublication.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports